import Image from "next/image";
import type { JSX } from "react";

export const PillMapping: Record<
    string,
    (maxWidth: number, lcp?: boolean) => JSX.Element
> = {
    "2de4184f-e5b6-4e8c-9657-cb4e1dda21c0": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Propranolol.png"}
            alt="Propranolol"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "ed9f4fd7-f1a9-45ab-870a-e0442fbd3e4c": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Guanfacine.png"}
            alt="Guanfacine"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "8bd7471e-f96f-4ba0-acba-11e02d8f79ee": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Midodrine.png"}
            alt="Midodrine"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "f7a49e75-3fb3-4a70-bf2f-944281a0a027": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Ivabradine.png"}
            alt="Ivabradine"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "0434efba-06f4-4281-aafa-bce184f995da": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Metformin.png"}
            alt="Metformin"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "5629ddb9-9850-497c-bb9e-7a8c041421f6": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Ketotifen.png"}
            alt="Ketotifen"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "9f1ebd6c-fd84-42b2-8b1e-a061f0a097c3": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Pyridostigmine.png"}
            alt="Pyridostigmine"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "1403cf8a-878b-426a-a9bf-0cf70bb95ea4": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/LDN.png"}
            alt="LDN"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "d3811816-208a-4521-9746-652dd59c5acd": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/CromolynSodium.png"}
            alt="CromolynSodium"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "165b45b2-a466-4f50-a4f6-83e3d5cfe5c3": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Montelukast.png"}
            alt="Montelukast"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "de44cad0-4764-44fa-b3c6-c81e905af407": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/Valcyclovir.png"}
            alt="Valacyclovir"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
    "323a6b17-9521-44d6-a7fa-94a0cb6723ee": (maxWidth, lcp = false) => (
        <Image
            src={"/images/pills/OAA.png"}
            alt="OAA"
            width={maxWidth}
            height={maxWidth}
            priority={lcp}
            loading={lcp ? "eager" : "lazy"}
        />
    ),
};

export const PillBGMapping: Record<string, string> = {
    "1403cf8a-878b-426a-a9bf-0cf70bb95ea4": "bg-[#E7D8E4]", // LDN
    "5629ddb9-9850-497c-bb9e-7a8c041421f6": "bg-[#D5DBE4]", // Ketotifen
    "9f1ebd6c-fd84-42b2-8b1e-a061f0a097c3": "bg-[#C7CED9]", // Pyridostigmine
    "ed9f4fd7-f1a9-45ab-870a-e0442fbd3e4c": "bg-[#EDB899]", // Guanfacine
    "2de4184f-e5b6-4e8c-9657-cb4e1dda21c0": "bg-[#EADBD2]", // Propranolol
    "f7a49e75-3fb3-4a70-bf2f-944281a0a027": "bg-[#F5C186]", // Ivabradine
    "8bd7471e-f96f-4ba0-acba-11e02d8f79ee": "bg-[#ED9D99]", // Midodrine
    "0434efba-06f4-4281-aafa-bce184f995da": "bg-[#E3E3E3]", // Metformin
    "165b45b2-a466-4f50-a4f6-83e3d5cfe5c3": "bg-[#D5DBE4]", // Montelukast
    "de44cad0-4764-44fa-b3c6-c81e905af407": "bg-[#D5DBE4]", // Valacyclovir
    "323a6b17-9521-44d6-a7fa-94a0cb6723ee": "bg-[#E6D9CD]", // Oxaloacetate
    "d3811816-208a-4521-9746-652dd59c5acd": "bg-[#D5DBE4]", // Cromolyn Sodium
};

export const BannerBGMapping: Record<string, string> = {
    "1403cf8a-878b-426a-a9bf-0cf70bb95ea4": "bg-[#E7D8E4]/30", // LDN
    "5629ddb9-9850-497c-bb9e-7a8c041421f6": "bg-[#D5DBE4]/30", // Ketotifen
    "9f1ebd6c-fd84-42b2-8b1e-a061f0a097c3": "bg-[#C7CED9]/30", // Pyridostigmine
    "ed9f4fd7-f1a9-45ab-870a-e0442fbd3e4c": "bg-[#EDB899]/30", // Guanfacine
    "2de4184f-e5b6-4e8c-9657-cb4e1dda21c0": "bg-[#EADBD2]/30", // Propranolol
    "f7a49e75-3fb3-4a70-bf2f-944281a0a027": "bg-[#F5C186]/30", // Ivabradine
    "8bd7471e-f96f-4ba0-acba-11e02d8f79ee": "bg-[#ED9D99]/30", // Midodrine
    "0434efba-06f4-4281-aafa-bce184f995da": "bg-[#E3E3E3]/30", // Metformin
    "165b45b2-a466-4f50-a4f6-83e3d5cfe5c3": "bg-[#D5DBE4]/30", // Montelukast
    "de44cad0-4764-44fa-b3c6-c81e905af407": "bg-[#D5DBE4]/30", // Valacyclovir
    "323a6b17-9521-44d6-a7fa-94a0cb6723ee": "bg-[#E6D9CD]/30", // Oxaloacetate
    "d3811816-208a-4521-9746-652dd59c5acd": "bg-[#D5DBE4]/30", // Cromolyn Sodium
};
